import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TokenService {
  private tokenInMemory: string | null = null;

  private tokenSubject = new BehaviorSubject<string | null>(null);
  public token$: Observable<string | null> = this.tokenSubject.asObservable();

  getToken(): string | null {
    return this.tokenInMemory;
  }

  setToken(token: string): void {
    this.tokenInMemory = token;
    this.tokenSubject.next(token);
  }

  extractTokenFromHeader(authHeader: string): string | null {
    if (authHeader && authHeader.startsWith('Bearer ')) {
      return authHeader.substring(7);
    }
    return null;
  }

  clearToken(): void {
    this.tokenInMemory = null;
    this.tokenSubject.next(null);
  }

}